import { render } from "./ProductCard.vue?vue&type=template&id=0afcf9c2&scoped=true&ts=true"
import script from "./ProductCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCard.vue?vue&type=script&setup=true&lang=ts"

import "./ProductCard.vue?vue&type=style&index=0&id=0afcf9c2&scoped=true&lang=css"
import "./ProductCard.vue?vue&type=style&index=1&id=0afcf9c2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0afcf9c2"],['__file',"src/components/ProductCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0afcf9c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0afcf9c2', __exports__)) {
    api.reload('0afcf9c2', __exports__)
  }
  
  module.hot.accept("./ProductCard.vue?vue&type=template&id=0afcf9c2&scoped=true&ts=true", () => {
    api.rerender('0afcf9c2', render)
  })

}


export default __exports__